import { hasCustomFormationCover, resolveFormationCoverUrl } from '@/lib/eduflow-formation-cover';

const GRADIENTS = [
  'linear-gradient(135deg, #7c3aed 0%, #312e81 100%)',
  'linear-gradient(135deg, #f97316 0%, #7c2d12 100%)',
  'linear-gradient(135deg, #2563eb 0%, #1e3a8a 100%)',
  'linear-gradient(135deg, #059669 0%, #064e3b 100%)',
  'linear-gradient(135deg, #db2777 0%, #831843 100%)',
];

export function formationCardGradient(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash + seed.charCodeAt(i) * (i + 1)) % GRADIENTS.length;
  }
  return GRADIENTS[hash] ?? GRADIENTS[0];
}

export function formationAuthorInitials(name?: string | null): string {
  if (!name?.trim()) return 'F';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
}

export function resolveFormationVisual(
  coverImageUrl?: string | null,
  gradientSeed = 'default',
): {
  hasCover: boolean;
  coverUrl: string;
  gradient: string;
} {
  const hasCover = hasCustomFormationCover(coverImageUrl);
  return {
    hasCover,
    coverUrl: hasCover ? resolveFormationCoverUrl(coverImageUrl) : '',
    gradient: formationCardGradient(gradientSeed),
  };
}

export function formatFormationModuleCount(blocksCount?: number | null): string {
  const count = blocksCount ?? 0;
  if (count <= 0) return '0 module';
  return count === 1 ? '1 module' : `${count} modules`;
}
